"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ZoomIn_exports = {};
__export(ZoomIn_exports, {
  default: () => ZoomIn_default
});
module.exports = __toCommonJS(ZoomIn_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.32812 6.08984C9.32812 5.94661 9.27604 5.82943 9.17188 5.73828C9.08073 5.63411 8.97005 5.58203 8.83984 5.58203C8.69661 5.58203 8.57292 5.63411 8.46875 5.73828C8.3776 5.82943 8.33203 5.94661 8.33203 6.08984V8.08203H6.33984C6.19661 8.08203 6.07292 8.13411 5.96875 8.23828C5.8776 8.32943 5.83203 8.44661 5.83203 8.58984C5.83203 8.72005 5.8776 8.83724 5.96875 8.94141C6.07292 9.03255 6.19661 9.07812 6.33984 9.07812H8.33203V11.0898C8.33203 11.2201 8.3776 11.3372 8.46875 11.4414C8.57292 11.5326 8.69661 11.5781 8.83984 11.5781C8.97005 11.5781 9.08073 11.5326 9.17188 11.4414C9.27604 11.3372 9.32812 11.2201 9.32812 11.0898V9.07812H11.3398C11.4701 9.07812 11.5807 9.03255 11.6719 8.94141C11.776 8.83724 11.8281 8.72005 11.8281 8.58984C11.8281 8.44661 11.776 8.32943 11.6719 8.23828C11.5807 8.13411 11.4701 8.08203 11.3398 8.08203H9.32812V6.08984ZM12.5898 13.043L15.9883 16.4414C16.0794 16.5326 16.1901 16.5781 16.3203 16.5781C16.4635 16.5781 16.5872 16.5326 16.6914 16.4414C16.7826 16.3372 16.8281 16.2201 16.8281 16.0898C16.8281 15.9466 16.7826 15.8294 16.6914 15.7383L13.293 12.3398C13.7227 11.832 14.0547 11.2591 14.2891 10.6211C14.5365 9.98307 14.6602 9.30599 14.6602 8.58984C14.6602 7.78255 14.5104 7.02083 14.2109 6.30469C13.8984 5.60156 13.4753 4.98958 12.9414 4.46875C12.4206 3.9349 11.8086 3.51172 11.1055 3.19922C10.4023 2.89974 9.64714 2.75 8.83984 2.75C8.03255 2.75 7.27083 2.89974 6.55469 3.19922C5.85156 3.51172 5.23307 3.9349 4.69922 4.46875C4.17839 4.98958 3.76172 5.60156 3.44922 6.30469C3.14974 7.02083 3 7.78255 3 8.58984C3 9.39714 3.14974 10.1523 3.44922 10.8555C3.76172 11.5586 4.17839 12.1771 4.69922 12.7109C5.23307 13.2318 5.85156 13.6484 6.55469 13.9609C7.27083 14.2604 8.03255 14.4102 8.83984 14.4102C9.55599 14.4102 10.2331 14.293 10.8711 14.0586C11.5091 13.8112 12.082 13.4727 12.5898 13.043ZM12.1406 12.1055C11.6979 12.5091 11.1966 12.8281 10.6367 13.0625C10.0768 13.2969 9.47786 13.4141 8.83984 13.4141C8.16276 13.4141 7.53125 13.2904 6.94531 13.043C6.35938 12.7826 5.84505 12.4375 5.40234 12.0078C4.97266 11.5651 4.63411 11.0508 4.38672 10.4648C4.1263 9.87891 3.99609 9.25391 3.99609 8.58984C3.99609 7.91276 4.1263 7.28125 4.38672 6.69531C4.63411 6.10938 4.97266 5.60156 5.40234 5.17188C5.84505 4.72917 6.35938 4.38411 6.94531 4.13672C7.53125 3.8763 8.16276 3.74609 8.83984 3.74609C9.50391 3.74609 10.1289 3.8763 10.7148 4.13672C11.3008 4.38411 11.8086 4.72917 12.2383 5.17188C12.681 5.60156 13.0326 6.10938 13.293 6.69531C13.5404 7.28125 13.6641 7.91276 13.6641 8.58984C13.6641 9.22786 13.5469 9.82682 13.3125 10.3867C13.0781 10.9466 12.7591 11.4479 12.3555 11.8906C12.3424 11.9036 12.3229 11.9167 12.2969 11.9297C12.2708 11.9427 12.2513 11.9622 12.2383 11.9883C12.2122 12.0013 12.1927 12.0208 12.1797 12.0469C12.1667 12.0729 12.1536 12.0924 12.1406 12.1055Z",
      fill: "currentColor"
    }
  )
);
const SvgZoomIn = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ZoomIn_default = SvgZoomIn;
